<template>
  <div class="tost-container">
    <div class="tost-warapper">
      <p class="tost-content">{{ tostContent }}</p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    tostContent() {
      return this.$store.state.dialog.tostContent;
    },
  },
};
</script>
<style>
.tost-container {
  z-index: 2000;
}
.tost-content {
  text-align: center;
}
</style>
